var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isMobile)?_c('ImageSettingsMobile',_vm._g(_vm._b({},'ImageSettingsMobile',_vm.imageSettingsProps,false),_vm.imageSettingsEmits)):_c('ImageSettingsDesktop',_vm._g(_vm._b({},'ImageSettingsDesktop',_vm.imageSettingsProps,false),_vm.imageSettingsEmits))
}
var staticRenderFns = []

export { render, staticRenderFns }